import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { QrCode, Heart, Check } from "lucide-react";
import { api, fileUrl } from "../lib/api";
import { PageHero } from "../components/ui-parts";

const AMOUNTS = [251, 501, 1001, 2100, 5100];

export default function Donate() {
  const [s, setS] = useState(null);
  const [amount, setAmount] = useState(501);
  const [custom, setCustom] = useState("");
  const [form, setForm] = useState({ full_name: "", mobile: "", email: "", address: "", purpose: "" });
  const [done, setDone] = useState(null);
  useEffect(() => { api.get("/settings").then(r => setS(r.data)); }, []);

  const submit = async (e) => {
    e.preventDefault();
    const amt = custom ? parseFloat(custom) : amount;
    try {
      const { data } = await api.post("/donations", { ...form, amount: amt });
      setDone(data.ref); toast.success(`Thank you! ${data.ref}`);
    } catch (err) { toast.error("Failed to record donation"); }
  };

  return (
    <div data-testid="donate-page">
      <PageHero badge="Support" title="Donate to Jayatu Sanskrutam" subtitle="Your contribution supports Sanskrit courses, teaching materials, training and volunteer activities across Odisha." />
      <section className="section">
        <div className="container-narrow grid gap-8 md:grid-cols-2">
          <div className="js-card p-8" data-testid="qr-section">
            <h3 className="font-heading text-2xl text-[var(--js-primary)] flex items-center gap-2"><QrCode /> Scan QR to Donate</h3>
            <div className="mt-6 flex flex-col items-center">
              {s?.qr_code_url ? (
                <img src={fileUrl(s.qr_code_url)} alt="Donation QR code" className="w-64 h-64 object-contain border border-[var(--js-border)] rounded-md bg-white p-2" data-testid="donation-qr-img" />
              ) : (
                <div className="w-64 h-64 flex items-center justify-center border border-dashed border-[var(--js-border)] rounded-md text-center text-sm text-[var(--js-muted)] p-6" data-testid="qr-placeholder">
                  Official QR code will be displayed here. Admin can upload it from the Admin Dashboard → Settings.
                </div>
              )}
              <p className="text-xs text-[var(--js-muted)] mt-4 text-center">Please write to us after donating so we can send a receipt.</p>
            </div>
            <div className="mt-6 text-sm text-[var(--js-muted)] space-y-1">
              <p>Your donation supports:</p>
              <ul className="list-disc list-inside space-y-1">
                <li>Free Sanskrit and Spoken Sanskrit courses</li>
                <li>Teaching materials and printed books</li>
                <li>Training programmes for teachers</li>
                <li>District-level volunteer activities</li>
                <li>Cultural and educational events</li>
              </ul>
            </div>
          </div>

          <div className="js-card p-8" data-testid="donation-form">
            <h3 className="font-heading text-2xl text-[var(--js-primary)] flex items-center gap-2"><Heart /> Pledge your support</h3>
            {done ? <div className="text-center py-8"><Check size={40} className="mx-auto text-[var(--js-accent)]" /><p className="mt-3 font-semibold">Thank you!</p><p className="font-mono text-[var(--js-primary)] mt-2">{done}</p><p className="text-sm text-[var(--js-muted)] mt-2">Please scan the QR code and complete your payment.</p></div> :
              <form onSubmit={submit} className="space-y-3 mt-4">
                <div className="flex flex-wrap gap-2">
                  {AMOUNTS.map(a => <button type="button" key={a} onClick={() => { setAmount(a); setCustom(""); }} data-testid={`amount-${a}`} className={`px-3 py-1.5 rounded-full text-sm font-semibold ${!custom && amount === a ? "bg-[var(--js-primary)] text-white" : "bg-white border border-[var(--js-border)]"}`}>₹ {a}</button>)}
                </div>
                <input type="number" placeholder="Custom amount" value={custom} onChange={e => setCustom(e.target.value)} data-testid="amount-custom" className="w-full px-3 py-2 rounded-md border border-[var(--js-border)] text-sm" />
                {[["full_name", "Full Name *"], ["mobile", "Mobile *"], ["email", "Email *"], ["address", "Address"], ["purpose", "Purpose (optional)"]].map(([k, l]) => (
                  <input key={k} required={l.includes("*")} type={k === "email" ? "email" : "text"} placeholder={l} value={form[k]} onChange={e => setForm(f => ({ ...f, [k]: e.target.value }))} data-testid={`donor-${k}`} className="w-full px-3 py-2 rounded-md border border-[var(--js-border)] text-sm" />
                ))}
                <button className="js-btn-primary w-full justify-center" data-testid="donate-submit">Record my pledge</button>
                <p className="text-xs text-[var(--js-muted)]">By recording your pledge, you help us track and acknowledge donations. Please complete your payment via QR.</p>
              </form>
            }
          </div>
        </div>
      </section>
    </div>
  );
}
